import Component from '@glimmer/component';

import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import ModalButton from 'rise-ui/components/modal-button.gjs';
import ModalCloseButton from 'rise-ui/components/modal-close-button.gjs';
import TabPanel from 'rise-ui/components/tab-panel.gjs';
import Body from 'rise-ui/components/ui-page/body.gjs';
import neq from 'rise-ui/helpers/neq.js';
import or from 'rise-ui/helpers/or.js';
import { getResultInfo } from 'rise-ui/utils/time-series/result.js';

export default class ViewApiRequestComponent extends Component {
  @service('time-series/graph-results') graphResults;

  @cached get results() {
    const results = [];
    if (this.args.all) {
      this.graphResults._outputs?.forEach(output => {
        results.push(getResultInfo(output.loader));
      });
    } else {
      results.push(getResultInfo(this.args.loader));
    }
    return results;
  }

  get apiRequestData() {
    return {
      apiRequest: {
        all: this.args.all,
        loader: this.args.loader,
        filename: this.args.filename,
        outputId: this.args.outputId,
        isModeled: this.args.isModeled,
      }
    }
  }

  <template>
    <ModalButton
      @title={{neq (or @title @text "Enter Value") (or @text "Enter Value")}}
      ...attributes
      as | mb |
    >
      <mb.button>View API Request{{#if @all}} For All{{/if}}...</mb.button>
      <mb.body>
        <div class="c-view-api-request">
          <ModalCloseButton @onClick={{mb.cancel}} />
          <TabPanel as | tab |>
            <tab @name="api" @title="RISE API">
              <Body @data={{this.apiRequestData}}
                @location={{if @all "view_api_all" "view_api"}}
              >
                <:error>Error fetching content</:error>
                <:default>API Request loading...</:default>
              </Body>
            </tab>
            <tab @name="download" @title="RISE Download API">
              <Body @data={{this.apiRequestData}}
                @location={{if @all "view_api_download_all" "view_api_download"}}
              >
                <:error>Error fetching content</:error>
                <:default>API Request loading...</:default>
              </Body>
            </tab>
          </TabPanel>
        </div>
      </mb.body>
    </ModalButton>
  </template>
}
